import { memo } from "react";
import { transformDateToLocalDateString } from "helpers";
import { ChipToggle } from "ui/modules/sales/pages/listings/components/ListingEditCard/components/MarketplaceStep/primitives";
import { AdditionalInfoCardProps } from "./types";
import { InfoCard, InfoGrid, Section } from "../primitives";

// Ostali podaci o vozilu — sekcija u stilu detalja oglasa.
const AdditionalInfoCard: React.FC<AdditionalInfoCardProps> = (props) => {
  const { formValues, details } = props;

  const asDate = (value: Date | null | undefined) =>
    value ? transformDateToLocalDateString(value) : null;

  return (
    <Section title="Ostali podaci o vozilu">
      <InfoGrid columns={3}>
        <InfoCard label="Prva registracija" value={asDate(formValues.firstRegistrationDate)} />
        <InfoCard label="Registrirano do" value={asDate(formValues.registrationExpiration)} />
        <InfoCard label="Jamstvo do" value={asDate(formValues.warrantyExpirationDate)} />

        <InfoCard
          label="Jamstvo do (km)"
          value={formValues.warrantyMileageLimit != null
            ? `${formValues.warrantyMileageLimit.toLocaleString("hr-HR")} km`
            : null}
        />
        <InfoCard label="Lokacija" value={formValues.location?.locationName} colSpan={2} />
      </InfoGrid>

      {/* Stoji ovdje otkad je video preselio u galeriju — inače bi se taj podatak izgubio. */}
      <div className="mb-3">
        <ChipToggle
          label="Razgledavanje video pozivom"
          selected={!!details?.videoCallViewing}
          readOnly
        />
      </div>
    </Section>
  );
};

export default memo(AdditionalInfoCard);
